import { FC } from 'react'
import React from 'react'
import numeral from 'numeral'
import { DataGridCell } from '@imodules/react-components/controls/DataGridCell'

import { DataGridRowProps } from './LeaderboardDataGrid'
import { DesignationCell } from './DesignationCell'

export interface RelativeCellProps {
    displayCell: boolean,
    data: any,
    cellName: string,
    width: number
}

export const RelativeCell: FC<RelativeCellProps> = props => (
    <>
        {props.displayCell && <DataGridCell
            className={`scoreboard-${props.cellName}-column data-grid-column`}
            widthType={{ kind: 'width', width: props.width }}
            isColumnHeader={false}
        > {props.data}
        </DataGridCell>}
    </>
)
export const MobileDataGridRow: FC<DataGridRowProps> = props => {
    const { name, totalDollars, recordCount, percentageOfAllContributers, percentageOfAllGifts, calculatedBonus, id, percentageOfGoal, goalAmount } = props.data
    const { parentFormBaseUrl, parentFormId } = props.leaderboardSettings
    const { displayRank,
        displayDollarsRaised,
        displayDonors,
        displayBonusAmount,
        displayPercentageOfDollars,
        displayGoals,
        displayPercentageOfGoals,
        percentageOfGoalsHeaderText,
        defaultGoals,
        goalsHeaderText,
        displayPercentageOfParticipation,
        appealCode,
        bonusAmountHeaderText,
        percentageOfParticipationHeaderText,
        percentageOfDollarsHeaderText,
        donorsHeaderText,
        dollarsRaisedHeaderText } = props.leaderboardSettings.layoutSettings
        const scoreboardTypeId = props.leaderboardSettings.scoreboardTypeId
    const isDisplayRank = displayRank ? <><span className="rank-span" style={{ whiteSpace: 'pre' }}>{`${props.rank}. `}</span>{name}</> : name
    return (
        < ul className="data-grid-row mobile-scoreboard" >
            <DesignationCell key="designation" data={isDisplayRank} parentFormBaseUrl={parentFormBaseUrl} parentFormId={parentFormId} designationId={id} appealCode={appealCode} />
            <div className="flex-row" >
                <RelativeCell key="donors" width={1} cellName="donors" displayCell={displayDonors} data={`${donorsHeaderText ? `${donorsHeaderText}:` : ''} ${recordCount}`} />
                <RelativeCell key="dollars" width={1} cellName="dollars" displayCell={displayDollarsRaised} data={<>{`${dollarsRaisedHeaderText ? `${dollarsRaisedHeaderText}:` : ''}`}<span className="currency-symbol-span">{imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>{numeral(totalDollars).format()}</>} />
            </div>
            <div className="flex-row">
                <RelativeCell key="bonus" width={1} cellName="bonus" displayCell={displayBonusAmount} data={<span>{`${bonusAmountHeaderText ? `${bonusAmountHeaderText}:` : ''}`}<span className="currency-symbol-span">{imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>{numeral(calculatedBonus).format()}</span>} />
                <RelativeCell key="percentageDollars" width={1} cellName="percentageDollars" displayCell={displayPercentageOfDollars && scoreboardTypeId === 13} data={<span>{`${percentageOfDollarsHeaderText ? `${percentageOfDollarsHeaderText}:` : ''} ${numeral(percentageOfAllGifts).format()}`}<span className="percent-symbol-span">%</span></span>} />
                <RelativeCell key="percentageParticipation" width={1} cellName="percentageParticipation" displayCell={displayPercentageOfParticipation} data={<span>{`${percentageOfParticipationHeaderText ? `${percentageOfParticipationHeaderText}:` : ''} ${numeral(percentageOfAllContributers).format()}`}<span className="percent-symbol-span">%</span></span>} />
            </div>
            <div className="flex-row">
                <RelativeCell key="percentageGoal" width={1} cellName="percentageGoal" displayCell={displayPercentageOfGoals} data={<span>{`${percentageOfGoalsHeaderText ? `${percentageOfGoalsHeaderText}:` : ''} ${numeral(percentageOfGoal).format()}`}<span className="percent-symbol-span">%</span></span>} />
                <RelativeCell key="goals" width={1} cellName="goals" displayCell={displayGoals} data={defaultGoals === 'Dollars' ? <>{`${goalsHeaderText ? `${goalsHeaderText}:` : ''}`}<span className="currency-symbol-span">{imod.cms.scoreboards.verbiage.globalCurrencySymbol}</span>{numeral(goalAmount).format()}</> : <>{`${goalsHeaderText ? `${goalsHeaderText}:` : ''} ${numeral(goalAmount).format()}`}</>} />
            </div>
        </ul >)
}
